import { AdminBlockAttributeInputType, AdminBlockTypeAttribute } from '@headlines/types/block/adminBlockType';

const contentSeparator: AdminBlockTypeAttribute = {
  label: 'Show content separator',
  key: 'contentSeparator',
  inputType: AdminBlockAttributeInputType.CHECKBOX,
};

export default contentSeparator;
